export default __webpack_public_path__ + "static/media/logo.f48fb565.png";